import { useCallback } from 'react';
import { useQueryAllPipelineTags, useAddTagToPipeline, useTrackWithUser } from '@ion/api';

import transformTagsToOptions from './transformTagsToOptions';
import transformPipelineTagsToOptions from './transformPipelineTagsToOptions';

export default function usePipelineTagAutocomplete({ pipelineId, currentTags }) {
  const { data: allTags, loading } = useQueryAllPipelineTags();
  const [trackTagAdded] = useTrackWithUser('pipeline_tag_added_to_pipeline');
  const [addTagToPipeline] = useAddTagToPipeline({ onCompleted: () => trackTagAdded() });

  const options = transformTagsToOptions(allTags);
  const value = transformPipelineTagsToOptions(currentTags);

  const handleChange = useCallback(
    (event, newValue) => {
      const added = findAdded(newValue, value);
      if (added) {
        addTagToPipeline({ pipelineId, label: added.label });
      }
    },
    [pipelineId, value, addTagToPipeline]
  );

  return {
    options,
    value,
    loading,
    handleChange,
  };
}

function findAdded(newValue, currentValue) {
  const currentIds = new Set(currentValue.map(tag => tag.id));
  return newValue.find(tag => !currentIds.has(tag.id));
}
